import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { spacingHelper } from '@property.com.au/ui-kit';
import stampBushfireColour from '../../../../assets/stamps/stamp-bushfire-colour.svg';
import stampBushfireGreyscale from '../../../../assets/stamps/stamp-bushfire-greyscale.svg';
import stampFloodColour from '../../../../assets/stamps/stamp-flood-colour.svg';
import stampFloodGreyscale from '../../../../assets/stamps/stamp-flood-greyscale.svg';
import stampHeritageColour from '../../../../assets/stamps/stamp-heritage-colour.svg';
import stampHeritageGreyscale from '../../../../assets/stamps/stamp-heritage-greyscale.svg';

export type StampType =
  | 'Bushfire_Greyscale'
  | 'Bushfire_Colour'
  | 'Flood_Greyscale'
  | 'Flood_Colour'
  | 'Heritage_Greyscale'
  | 'Heritage_Colour';
const stampMap: Record<StampType, string> = {
  Bushfire_Greyscale: stampBushfireGreyscale,
  Bushfire_Colour: stampBushfireColour,
  Flood_Greyscale: stampFloodGreyscale,
  Flood_Colour: stampFloodColour,
  Heritage_Greyscale: stampHeritageGreyscale,
  Heritage_Colour: stampHeritageColour,
};

interface StampProps {
  stamp: StampType;
  className?: string;
}

const mapStamp = (stamp: StampType): string => stampMap[stamp];

const StyledImage = styled.img`
  max-height: ${spacingHelper('twoExtraLarge')};
`;

export const Stamp: FunctionComponent<StampProps> = ({ stamp, className }) => {
  return <StyledImage src={mapStamp(stamp)} alt={`${stamp} icon`} className={className} />;
};
